<label [for]="id" [class]="required ? 'required' : ''" [innerText]="label"></label>
<ng-select
    [name]="name"
    [labelForId]="id"
    [items]="items"
    [(ngModel)]="selectValue"
    (change)="updateValue()"
    [disabled]="disabled"
    [required]="required"
    [clearable]="clearable"
    [clearOnBackspace]="false"
    [markFirst]="false"
    notFoundText="Keine Einträge gefunden"
    dropdownCustomHoverColorDirective
    otbAnnounceSearchResults
>
</ng-select>
@if (helpText !== null) {
    <small class="form-text text-muted" [innerText]="helpText"></small>
}
